import { IconChevronDownSmall16, UIText2 } from '@cian/ui-kit';

import { clsx } from 'clsx';
import * as React from 'react';

import styles from './ExpandWrapper.css';

interface IExpandWrapperProps {
  text: string;
  isExpanded: boolean;
  onToggle: () => void;
}

export const ExpandWrapper: React.FC<React.PropsWithChildren<IExpandWrapperProps>> = ({
  children,
  text,
  isExpanded,
  onToggle,
}) => {
  return (
    <div className={styles['container']}>
      <div className={clsx(styles['options-container'], { [styles['open']]: isExpanded })}>{children}</div>
      <button className={styles['expand-button']} onClick={onToggle}>
        <UIText2 color="primary_100">{text}</UIText2>
        <div className={clsx(styles['arrow'], { [styles['rotated']]: isExpanded })}>
          <IconChevronDownSmall16 color="primary_100" />
        </div>
      </button>
    </div>
  );
};
